@if (isLoading$ | async) {
  <div class="fixed left-0 top-0 z-[999] w-full">
    <div class="loader"></div>
  </div>
}
